import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 9700DCD7-8658-479A-A817-1241A09F9654
 * name play-box-multiple
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/play-box-multiple.svg
 * tags
 */
export const PlayBoxMultipleIcon = createSvgIcon(<><path d="M4,6H2V20A2,2 0 0,0 4,22H18V20H4V6M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M12,14.5V5.5L18,10L12,14.5Z" /></>, 'PlayBoxMultipleIcon');
export default PlayBoxMultipleIcon